import { useMemo } from 'react';
import { AccountType } from 'shared/types/account/Account';
import { useFormat } from 'helpers/hooks/useFormat';

const useAccountType = () => {
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  const accountTypes: { value: AccountType; label: string }[] = useMemo(() => {
    return [
      {
        value: 'personal',
        label: formatAccountMessage({ id: 'personal', defaultMessage: 'Personal' }),
      },
      {
        value: 'business',
        label: formatAccountMessage({ id: 'business', defaultMessage: 'Business' }),
      },
    ];
  }, [formatAccountMessage]);

  return {
    accountTypes,
  };
};

export default useAccountType;
